/**
 * Fond de la page de connexion : le VRAI tableau de bord du responsable, rendu
 * par l'aperçu de démonstration (`apercu.html`, données fictives, aucun réseau).
 * Il reste à jour avec l'interface puisqu'il s'agit des mêmes composants.
 *
 * Purement décoratif : flouté, inerte, masqué aux lecteurs d'écran, hors de
 * l'ordre de tabulation. Économie de données demandée : on ne le charge pas.
 */
import { useState, type ReactNode } from 'react';
import { useAuth } from '../../core/auth.js';
import { resolvedTheme } from '../../core/theme.js';

/** Faux dans un cadre (jamais d'imbrication) ou en mode économie de données. */
export function loginBackdropEnabled(): boolean {
  const connection = (navigator as Navigator & { connection?: { saveData?: boolean } }).connection;
  return connection?.saveData !== true && window.self === window.top;
}

export function LoginBackdrop(): ReactNode {
  const { theme } = useAuth();
  const [loaded, setLoaded] = useState(false);
  const resolved = resolvedTheme(theme, new Date());
  // Fragment plutôt que paramètre : l'URL reste celle mise en cache hors ligne.
  const hash = resolved === 'auto' ? '' : `#${resolved}`;
  return (
    <div className={`login-backdrop${loaded ? ' login-backdrop--loaded' : ''}`} aria-hidden="true">
      <iframe
        className="login-backdrop__frame"
        src={`/apercu.html${hash}`}
        title="Aperçu de MyEquip"
        tabIndex={-1}
        inert
        referrerPolicy="no-referrer"
        sandbox="allow-scripts allow-same-origin"
        onLoad={() => setLoaded(true)}
      />
      <span className="login-backdrop__veil" />
    </div>
  );
}
